import {Typography} from "@mui/material";

export const CdpInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Data Points',
                content: (
                    <>
                        <Typography paragraph>
                            These are the Data Points originating from
                            this Contract Section.
                        </Typography>

                        <ul>
                            <li>
                                Contract Data Points will be transcribed
                                onto individual contract models.
                            </li>

                            <li>
                                Contract Data Points can perform calculations,
                                provide values, and can be used to match
                                to Contract Section Filters.
                            </li>

                            <li>
                                Contract Section Filter matches determine
                                which additional Contract Data Points
                                get added to the individual contract model.
                            </li>

                            <li>
                                Add, edit, and order the Contract Data Points.
                            </li>

                            <li>
                                Decide if they should be filtered
                                to only a single Contract Level
                                of individual contract models,
                                or if they will match to any
                                Contract Level.
                            </li>

                            <li>
                                A Destination Folder must be selected.
                            </li>

                            <li>
                                The Destination Folder drives
                                some of the functionality of how
                                the Contract Data Point will be
                                handled by the system.
                            </li>

                            <li>
                                A Contract Data Point must be assigned
                                at least one Contract Data Point Value.
                            </li>

                            <li>
                                Contract Data Point Value Filters
                                can be applied to Contract Data Point Values
                                to filter which value or values
                                will be assigned to the Contract Data Point
                                when it attaches to a contract model.
                            </li>
                        </ul>
                    </>
                )
            }
            //     content: 'These are the Data Points originating from this Contract Section.  ' +
            //         'Contract Data Points will be transcribed onto individual contract models.  ' +
            //         'Contract Data Points can perform calculations, provide values,' +
            //         ' and can be used to match to Contract Section Filters thereby driving which additional ' +
            //         'Contract Data Points get added the individual contract model.  Add, edit and order the Contract Data Points.  ' +
            //         'Decide if they should be filtered to only a single Contract Level of individual contract models, ' +
            //         'or if they will match to any Contract Level.  A Destination Folder must be selected, and this will drive ' +
            //         'some of the functionality of how the Contract Data Point will be handled by the system.  ' +
            //         'A Contract Data Point must be assigned at least one Contract Data Point Value.' +
            //         '  Contract Data Point Value Filters can be applied to Contract Data Point Values ' +
            //         'to filter for which one(s) will be assigned to the Contract Data Point when it attaches to a contract model.'
            // };

    }

    };